import i18next from 'i18next';
import {
    EVENT
} from '../../../common/events/listEvents';

export default class ToastGeneratorAction {

    static translate(key) {
        return i18next.t(key)
    }
    
    static generateToast(param) {
        window.toastComp = {
            ...param,
            className: param.className || ''
        };
        window.fireEvent(EVENT.GENERATE_TOAST);
    }
   
    /** 
     * text will be a array because we can have multiple line of text
     * classname can be active, warning or error. CSS of toast component will be render base on that value.
     */
    static generateAddingSelectionToast(oddsId, messages, className, tapOnLinkAction) {
      window.toastComp = {};
      window.toastComp.messages = messages;
      window.toastComp.oddsId = oddsId;
      window.toastComp.tapOnLinkAction = tapOnLinkAction
      if (!(typeof className == "undefined" || className == null)) {
        window.toastComp.className = className;
      }
      window.fireEvent(EVENT.GENERATE_ADDING_SELECTION_TOAST);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/ToastGeneratorComponent/ToastGeneratorAction.js